<template lang="html">
  <div class="col-lg-6 lbv-water-usage">
    <b-card header="Water Usage">
      <form class="form">
        <div class="form-row">
          <label
            for="water-usage-date-from"
            class="col-form-label"
          >Date from</label>
          <b-form-input
            id="water-usage-date-from"
            v-model="from"
            type="date"
            @change="fromChangeHandler"
          />
          <label
            for="water-usage-date-to"
            class="col-form-label"
          >Date to</label>
          <b-form-input
            id="water-usage-date-to"
            v-model="to"
            type="date"
            @change="toChangeHandler"
          />
        </div>
        <div class="form-row action">
          <button
            type="button"
            class="btn btn-primary"
            @click.prevent="showReport"
          >
            Visualise Report
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click.prevent="downloadReport"
          >
            Download Report
          </button>
        </div>
      </form>
    </b-card>
    <b-modal
      id="waterUsage"
      ref="waterModal"
      ok-only
    >
      <div
        slot="modal-header"
        class="header-wrapper"
      >
        <h1 class="water-pad">
          LeakBot ID: <span>{{ device_id }}</span>
        </h1>
        <div class="water-close water-pad">
          <a
            href="#"
            @click.prevent="closeModal"
          >X</a>
        </div>
        <div class="water-download water-pad">
          <button
            type="button"
            class="btn btn-primary"
            @click.prevent="downloadReport"
          >
            Download
          </button>
        </div>
        <div class="water-form water-pad">
          <label
            for="water-usage-date-from"
            class="col-form-label"
          >Date from</label>
          <b-form-input
            id="water-usage-date-from-modal"
            v-model="from"
            type="date"
            @change="fromChangeHandler"
          />
          <label
            for="water-usage-date-to"
            class="col-form-label"
          >Date to</label>
          <b-form-input
            id="water-usage-date-to-modal"
            v-model="to"
            type="date"
            @change="toChangeHandler"
          />

          <button
            type="button"
            class="btn btn-primary apply"
            @click.prevent="showReport"
          >
            Apply
          </button>
        </div>
      </div>
      <div
        v-model="waterUsage"
        class="water-usage-wrapper"
      >
        <table>
          <tr v-for="day in waterUsage">
            <th>{{ day.message_timestamp | getFormattedDate }}</th>
            <td
              v-for="status in day.water_usage"
              class="water-status"
            >
              <div :class="status | getUsageLabel" />
            </td>
          </tr>
          <tr>
            <td />
            <td
              v-for="time in timePoints"
              class="timePoints"
            >
              {{ time }}
            </td>
          </tr>
        </table>
      </div>
      <div
        slot="modal-footer"
        class="water-legend"
      >
        <div class="legend-holder">
          <ul>
            <li class="use">
              <span class="color-box" />Water Use
            </li>
            <li class="no-use">
              <span class="color-box" />No Use
            </li>
            <li class="no-signal">
              <span class="color-box" />No Signal
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { APIEvent } from '../../events/apiEvent'
import { StatusBarEvent } from '../../events/statusBarEvent'
import { EventBus } from '../../event-bus'
import { JSONToCSVConvertor, createReportLabel } from '../../utils'

export default {
  name: 'WaterUsage',
  filters: {
    getFormattedDate: function (date) {
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      let dString = date.split(' ')[0]
      let d = new Date(dString)
      return d.getDate() + ' ' + months[d.getMonth()]
    },
    getUsageLabel: function (status) {
      let translations = ['none', 'use', 'no-data']
      return translations[status]
    }
  },
  props: ['lb_id', 'device_id'],
  data () {
    return {
      from: '',
      to: '',
      waterUsage: {},
      timePoints: []
    }
  },
  methods: {
    showReport: function () {
      this.createReport(false)
    },
    downloadReport: function () {
      this.createReport(true)
    },
    validDates: function () {
      return this.from !== '' && this.to !== ''
    },
    createReport: function (download) {
      var options = {}
      if (!this.validDates()) {
        let error = {}
        let verb = download ? 'Download' : 'Visualise'
        error.message = 'Please enter a valid date before clicking on ' + verb + ' Report'
        this.handleError(error)
        return
      }
      options.from = this.from + ' 00:00:00'
      options.to = this.to + ' 23:59:59'
      options.LbDevice_ID = this.lb_id
      this.$store.dispatch(APIEvent.FETCH_WATER_USAGE, options)
        .then((response) => {
          if (response.data.list === '') {
            EventBus.$emit(StatusBarEvent.WARNING, 'Date range has no data')
          } else {
            this.waterUsage = this.arrangeWaterUsage(response.data.list.record)
            this.createTimePoints()
            if (download) {
              this.download()
            } else {
              this.$refs.waterModal.show()
            }
          }
        })
        .catch(this.handleError)
    },
    closeModal: function () {
      this.$refs.waterModal.hide()
    },
    arrangeWaterUsage: function (data) {
      for (var i = 0; i < data.length; i++) {
        data[i].water_usage = JSON.parse(data[i].water_usage)
      }
      return data
    },
    createTimePoints: function () {
      if (this.timePoints.length === 0) {
        for (var i = 0; i < 48; i++) {
          var delta = 30
          var totalTime = i * delta
          var hours = this.paddNumber(Math.floor(totalTime / 60))
          var mins = this.paddNumber(totalTime % 60)
          this.timePoints.push(hours + ':' + mins)
        }
      }
    },
    paddNumber: function (number) {
      return number.toString().length < 2 ? '0' + number : number
    },
    fromChangeHandler: function (date) {
      let otherInput = document.getElementById('water-usage-date-to')
      this.to = this.checkDateRange(date, otherInput, 1)
    },
    toChangeHandler: function (date) {
      let otherInput = document.getElementById('water-usage-date-from')
      this.from = this.checkDateRange(date, otherInput, -1)
    },
    checkDateRange: function (date, otherInput, direction) {
      let restrictedDate
      let selectedDate = new Date(date).getTime()
      let sevenDays = direction * (86400 * 7 * 1000) // seconds in a day times 7 days
      restrictedDate = new Date(selectedDate + sevenDays - (1000 * direction)).toISOString()
      restrictedDate = restrictedDate.split('T')[0]
      otherInput.max = otherInput.value = restrictedDate
      return restrictedDate
    },
    download: function () {
      // concat to return the a copy of array rather than affect the model
      let headings = this.timePoints.concat()
      headings.splice(0, 0, 'Date')
      let jsonData = JSON.stringify(this.createArrayForReportDownload())
      var title = createReportLabel('Water Usage')
      JSONToCSVConvertor(jsonData, title, true, headings)
    },
    createArrayForReportDownload: function () {
      let entries = []
      for (var i = 0; i < this.waterUsage.length; i++) {
        // concat to return the a copy of array rather than affect the model
        let entry = this.waterUsage[i].water_usage.concat()
        entry.splice(0, 0, this.waterUsage[i].message_timestamp)
        entries.push(entry)
      }
      return entries
    },
    handleError: function (error) {
      EventBus.$emit(StatusBarEvent.ERROR, error.message)
    }
  }
}
</script>

<style lang="css">
  #water-usage-date-from, #water-usage-date-to {
    width: 155px;
  }

  #waterUsage .modal-dialog {
    max-width: max-content;
  }

  #waterUsage .modal-header {
    padding: 0px;
  }

  #waterUsage .header-wrapper {
    width: 100%;
  }

  #waterUsage .modal-header, .water-usage-wrapper {
    border-bottom: 1px solid #c2cfd6 !important;
  }
  .water-usage-wrapper {
    padding-bottom: 1rem;
  }

  #waterUsage h1 {
    font-size: 1rem;
    text-align: left;
    font-weight: bold;
    float: left;
    margin-top: 1rem;
  }

  #waterUsage h1 span{
    font-weight: normal;
  }

  #waterUsage .water-close {
    padding-left: 0px;
  }

  #waterUsage .water-close a, #waterUsage .water-close a:hover{
    color: #c2cfd6;
    text-decoration: none;
    font-size: 1.7rem;
  }

  .timePoints {
    font-size: 0.5rem;
  }

  .water-form, .water-close, .water-download {
    float: right;
    margin-left: 1rem;
  }

  .water-form, .water-download {
    border-right: 1px solid #c2cfd6;
  }

  .water-form .apply {
    margin-left: 1rem;
  }

  .water-download {
    padding: 0.5rem;
  }

  .water-pad {
    padding: 15px;
  }

  .water-status div {
    width: 20px;
    height: 40px;
  }

  .water-status .none, .water-legend .no-use .color-box {
    background-color: rgb(11, 27, 82);
  }
  .water-status .use, .water-legend .use .color-box {
    background-color: rgb(50, 211, 197);
  }
  .water-status .no-data, .water-legend .no-signal .color-box {
    background-color: rgb(252, 89, 109);
  }

  .water-legend ul li {
    display: inline-block;
    margin-right: 10px;
    vertical-align: middle;
  }

  .water-legend .color-box {
    display: inline-block;
    position: relative;
    top: 6px;
    width: 25px;
    height: 25px;
    margin-right: 5px;
  }


</style>
